import React from 'react';
import '../index.css';

export default function Page() {

   return (
      <div className='page'>
         <div id="block1">
            <h1>Milton Melson</h1>
            <h3>Veteran and CSSE Student at UWB</h3>
         </div>
         <div id='block2'>
            <h1>About Me</h1>
            <p>
               Hello, I'm Milton Melson. As a former Aviation Support Equipment Technician in the Navy, 
               I cherished my time serving my country. However, I've now decided to pursue new skills and opportunities. 
               Currently, I'm studying Computer Science and Software Engineering at the University of Washington at Bothell. 
               I'm excited about the prospect of expanding my knowledge and contributing to the tech industry.
            </p>
            <p>
               In most of my school projects, I primarily utilize C++. However, in my Operating Systems class, 
               I have gained experience in using Java as well. I'm also taking courses such as VetsInTech to 
               further expand my knowledge. In my free time, I have been teaching myself other programming languages 
               such as JavaScript, HTML, and CSS. To enhance my proficiency, 
               I have been working on small projects using tools like node.js, mongoDB, Express, and React.
            </p>
            <p>
               I created this website as a central hub for my more interactive projects and to gain proficiency in React. 
               For my less interactive projects written in C++, you can find them on my GitHub page by clicking on the 
               link provided at the top of this site.
            </p>
         </div>
      </div>
   )
}

